import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';

/**
 * Carries the current operator's opaque UI settings bag.
 *
 * `id` is null on GET when no row exists. That nullability is local to
 * this DTO; {@link BaseDto} stays `id: number`.
 */
@CaslSubject(AppSubjectEnum.USER_APP_SETTINGS)
export class UserAppSettingsDto {
  id!: number | null;
  color?: string | null;
  createdAt?: Date;
  createdByUserId?: number | null;
  createdByUsername?: string | null;
  updatedAt?: Date | null;
  updatedByUserId?: number | null;
  updatedByUsername?: string | null;
  userId!: number;
  settingsValues!: Record<string, unknown>;
}
